// extracted by mini-css-extract-plugin
export default {"tooltip":"zA-z","arrow":"AA-z"};